define('global/UI/Helpers',[
    'jquery',
    'global/Logger'
], function ($, Logger) {
    'use strict';
    Logger.debug('Setting up Helper functions & constants...');

    var resizeObject = {};
    var resizeFunctionsArray = [];
    var resizeUpdater = function () {
        // window sizes
        resizeObject.windowWidth = $(window).outerWidth();
        resizeObject.windowHeight = $(window).outerHeight();

        resizeFunctionsArray.forEach(function (fn) {
            fn();
        });
    }
    resizeUpdater();

    var constantsObject = {
        // screenExtraSmallMax: 767,
        // screenSmallMin: 768,
        // screenSmallMax: 991,
        screenMediumMin: 992,
        // screenMediumMax: 1365,
        // screenLargeMin: 1366,
    }

    // Debouncer
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args) };
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args) };
        };
    };

    // binds resizeUpdater to the resize event.
    $(window).on("resize", resizeUpdater);

    var Helpers = {
        constantsObject: constantsObject,
        resizeObject: resizeObject,
        resizeFunctionsArray: resizeFunctionsArray,
        resizeUpdater: resizeUpdater,
        debounce: debounce
    };

    return Helpers;
});



